import React, { useState } from 'react';
import TeamSelector from '../components/TeamSelector';

const TestTeamSelector = () => {
  const [selectedTeam, setSelectedTeam] = useState(null);

  const handleTeamChange = (team) => {
    console.log('TestTeamSelector: Team changed to:', team);
    setSelectedTeam(team);
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Team Selector Test</h1>
      
      <div className="mb-4">
        <h2 className="text-lg font-semibold mb-2">Team Selector Component:</h2>
        <TeamSelector onTeamChange={handleTeamChange} />
      </div>
      
      <div className="mb-4">
        <h2 className="text-lg font-semibold mb-2">Selected Team:</h2>
        <pre className="bg-gray-100 p-4 rounded">
          {selectedTeam ? JSON.stringify(selectedTeam, null, 2) : 'No team selected'}
        </pre>
      </div>
    </div>
  );
};

export default TestTeamSelector;
